module.exports = __webpack_public_path__ + "img/f280-verified.ffe98a9a.png";